import { get, isEmpty } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HeadingText, CaptionText } from '@paypalcorp/pp-react-text';
import { Button } from '@paypalcorp/pp-react-buttons';
import { injectIntl, intlShape } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';

import UploadCard from './components/UploadCard';
import { CONFIRMATION, FINAL_SUBMIT_ERROR } from './constants/slides';
import { LoadingScreen } from './components/LoadingScreen';
import CancelUrl, { COMPONENT_STYLE } from '../../components/CancelUrl/CancelUrl';
import { submitDocumentsApi } from './DocumentsReqPageAction';
import { VERIFICATION_STATUS } from './constants/status';
import { verificationFilter } from './utils/verificationFilter';
import { getAppPendVerificationDetails } from './AppPendPageAction';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';

import './DocumentsReqPage.less';

const LOCALE_PREFIX = 'US/pages/AppPendPage/DocumentsRequired';
const submitText = `${LOCALE_PREFIX}.SUBMIT_DOCUMENT_BUTTON`;
const finishLaterText = `${LOCALE_PREFIX}.FINISH_LATER_BUTTON`;
let loadingText = `${LOCALE_PREFIX}.LOADING_SCREEN_TEXT`;

export class DocumentsRequired extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        workflowId: PropTypes.string.isRequired,
        dueDate: PropTypes.string.isRequired,
        workflowStatus: PropTypes.string.isRequired,
        requiredDocuments: PropTypes.array.isRequired,
        submitCall: PropTypes.func,
        finalUvsResponse: PropTypes.object,
        navigate: PropTypes.func,
        onComponentDidMount: PropTypes.func,
        finalSubmitRetryCount: PropTypes.number
    };
    state = {
        uploadedDocuments: {},
        isSubmitBtnClicked: false
    };

    finalSubmitCallToUvs = () => {
        const { workflowId, submitCall } = this.props;
        loadingText = `${LOCALE_PREFIX}.LOADING_SCREEN_SUBMIT_TEXT`;
        this.setState({ isSubmitBtnClicked: true });
        submitCall(workflowId);
    };

    finalSubmitCallToError = () => {
        this.setState({
            isSubmitBtnClicked: false
        });
    };

    componentDidMount() {
        const { onComponentDidMount, finalSubmitRetryCount } = this.props;
        // handle final submit error, on re-try will navigate from error page to this page and run a new getVerification call
        if (finalSubmitRetryCount > 0) {
            loadingText = `${LOCALE_PREFIX}.LOADING_SCREEN_TEXT`;
            onComponentDidMount();
        }
    }

    uploadDocument = (url, fileInputMeta, type) => {
        const { name, size } = fileInputMeta;
        const { uploadedDocuments } = this.state;
        this.setState({
            uploadedDocuments: {
                ...uploadedDocuments,
                [type]: {
                    url,
                    name,
                    size
                }
            }
        });
    };

    cancelButton = () => {
        const { intl } = this.props;
        return (
            <>
                <CaptionText className="file-size-limit-text document-info-text">
                    {intl.formatMessage({ id: `${LOCALE_PREFIX}.ACCEPTABLE_DOCUMENTS_TEXT` })}
                </CaptionText>
                <CancelUrl
                    componentType={COMPONENT_STYLE.LINK_BUTTON}
                    customCancelLinkMessage={finishLaterText}
                    fptiEvent={{
                        stateName: 'apply_pp_credit_uploadDocument',
                        transitionName: 'finishLater_pp_credit_uploadDocument'
                    }}
                />
            </>
        );
    };

    submitButton = (intl, buttonText) => (
        <Button onClick={this.finalSubmitCallToUvs} className="appPendSubmitBtn" >
            {intl.formatMessage({ id: buttonText })}
        </Button>
    );

    renderDocumentUploadData = (showDocRequired, isAlreadyUploaded, enableSubmit) => {
        const { intl, dueDate } = this.props;
        return (
            <>
                <HeadingText className="appPendSheetHeading" size="md">{intl.formatMessage({ id: `${LOCALE_PREFIX}.ADD_DOC-primary-text` })}</HeadingText>
                <CaptionText>
                    <p className="document-description-text document-info-text">{intl.formatMessage({ id: `${LOCALE_PREFIX}.ADD_DOC-sub-text1` })}</p>
                    <p className="document-description-text">{intl.formatMessage({ id: `${LOCALE_PREFIX}.ADD_DOC-sub-text2` }, { dueDate })} </p>
                </CaptionText>
                <div className="uploadCardContainer">
                    {this.renderRequiredDocs(showDocRequired, isAlreadyUploaded)}
                    {enableSubmit ? this.submitButton(intl, submitText) : this.cancelButton()}
                </div>
            </>
        );
    };

    renderRequiredDocs = (showDocRequired, isAlreadyUploaded) => {
        const { intl } = this.props;
        const { uploadedDocuments } = this.state;
        return showDocRequired.map(verification => {
            const { type, verificationId, targetEntity } = verification;
            return (
                <UploadCard key={type}
                    captionText={intl.formatMessage({ id: `${LOCALE_PREFIX}.${type}-header`})}
                    acceptableDocuments={intl.formatMessage({ id: `${LOCALE_PREFIX}.${type}-SUB-ITEMS`}).split('|')}
                    type={type}
                    verificationId={verificationId}
                    targetEntity={targetEntity}
                    uploadedDocuments={uploadedDocuments}
                    uploadDocument={this.uploadDocument}
                    isAlreadyUploaded={isAlreadyUploaded}
                />
            );
        });
    };

    render() {
        const { requiredDocuments, finalUvsResponse, navigate } = this.props;
        const documentsToBeUploaded = verificationFilter(requiredDocuments, VERIFICATION_STATUS.NONE);

        if (!isEmpty(finalUvsResponse)) {
            if (finalUvsResponse.success) {
                navigate(CONFIRMATION);
            } else {
                navigate(FINAL_SUBMIT_ERROR);
            }
        }

        let showDocRequired = [];
        let isAlreadyUploaded = false;
        let enableSubmit = false;

        if (documentsToBeUploaded.length) {
            showDocRequired = documentsToBeUploaded;
            const { uploadedDocuments } = this.state;
            if (showDocRequired.length === Object.keys(uploadedDocuments).length) {
                enableSubmit = true;
            }
        } else {
            showDocRequired = verificationFilter(requiredDocuments, VERIFICATION_STATUS.PENDING);
            isAlreadyUploaded = true;
            enableSubmit = true;
        }

        return (
            <div className="documentRequired">
                {(showDocRequired.length && !this.state.isSubmitBtnClicked)
                    ? this.renderDocumentUploadData(showDocRequired, isAlreadyUploaded, enableSubmit)
                    : <LoadingScreen loadingText={loadingText} />
                }
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    finalUvsResponse: get(state, 'serverData.appPendData.finalUvsResponse', {})
});

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        return dispatch(getAppPendVerificationDetails());
    },
    submitCall(workflowId) {
        dispatch(trackTransition('apply_pp_credit_uploadDocument', 'submitDocuments_pp_credit_uploadDocument', { ...(workflowId && { workflow_id: workflowId }) }));
        return dispatch(submitDocumentsApi());
    }
});

export default compose(
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps)
)(DocumentsRequired);
